let theme = {
  primary: "#701416",
}

export default theme
